import { DecisionTree } from "#/decision_tree_viewer/models/decision-tree";
import { BaseDecisionTreeViewerApi } from "./base";

class DecisionTreeApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: DecisionTree, baseURL: "/decision_trees" });
  }
}

let api;

export const createDecisionTreeApi = () => {
  api ??= new DecisionTreeApi();

  return {
    find: async (id) => api.get(id.toString()),
  };
};
